import React, {Suspense} from 'react';
import {observer} from "mobx-react-lite";
import {useAppState} from "@stores/AppStateContext";

import {CreateWorkspace} from "../CreateWorkspace";
import {Invite} from "../Invite";
import {ImagePreview} from "../ImagePreview";
import {UserDeleteModal} from "../components/UserDeleteModal";
import {UnsavedChangesConfirm} from "../UnsavedChangesConfirm/UnsavedChangesConfirm";
import {UnsavedTakeQuizConfirm} from "../UnsavedTakeQuizConfirm/UnsavedTakeQuizConfirm";
import {AiQuiz} from "../AiQuiz"
import {WorkspaceConfirmDelete} from "../WorkspaceConfirmDelete"
import {AddMembersWorkspace} from "../AddMembersWorkspace";
import {RemoveUserFromWorkspace} from "../RemoveUserFromWorkspace"
import {CropModal} from "../CropModal";
import {RemoveAcknowledgmentRequire} from "../RemoveAcknowledgmentRequire/RemoveAcknowledgmentRequire";
import {TaskListUnitEdit} from "../TaskListUnitEdit/TaskListUnitEdit";
import {TaskListEdit} from "../TaskListEdit/TaskListEdit";
import {TaskEdit} from "../TaskEdit/TaskEdit";
import {TaskReportEdit} from "../TaskReportEdit/TaskReportEdit";
import {CopyToForTaskModal} from "../CopyToForTaskModal";
import {LightBoxModal} from "../LightBoxModal/LightBoxModal";
import {YearCalendar} from "../YearCalendar/YearCalendar"
import {ExceptionsCalendar} from "../ExceptionsCalendar/ExceptionsCalendar"
import {TaskListDelete} from "../TaskListDelete"
import {TaskDelete} from "../TaskDelete/TaskDelete";
import {DocumentViewModal} from "../DocumentViewModal/DocumentViewModal";
import {TaskReportViewOnly} from "../TaskReportViewOnly/TaskReportViewOnly";
import {DeleteTaskListUnit} from "../DeleteTaskListUnit";
import {PriceBreakdownModal} from "../PriceBreakdownModal/PriceBreakdownModal";

import {MODALS} from "../modal-names";
import {ModalEntry} from "../../../../stores/ModalController";

const ImportDocLazy = React.lazy(() => import('../ImportDoc'));

export const ModalManager = observer(() => {
    const appState = useAppState();
    const entries = appState.modalController.modals;
    return (
        <>
            {
                entries.map(entry => renderModal(entry))
            }
        </>
    )
});

const renderModal = ({ name, params }: ModalEntry) => {
    switch (name) {
        case MODALS.CREATE_WORKSPACE:
            return <CreateWorkspace key={name} />;
        case MODALS.ADD_MEMBERS_WORKSPACE:
            return <AddMembersWorkspace key={name} {...params}/>
        case MODALS.REMOVE_USER_FROM_WORKSPACE:
            return <RemoveUserFromWorkspace key={name} {...params}/>
        case MODALS.DELETE_WORKSPACE:
            return <WorkspaceConfirmDelete key={name} {...params}/>
        case MODALS.INVITE:
            return <Invite key={name}/>;
        case MODALS.IMAGE_PREVIEW:
            return <ImagePreview key={name} {...params}/>;
        case MODALS.USER_DELETE:
            return <UserDeleteModal key={name} {...params}/>;
        case MODALS.PRICE_BREAKDOWN:
            return <PriceBreakdownModal key={name} {...params}/>;
        case MODALS.UNSAVED_CHANGE_CONFIRM:
            return <UnsavedChangesConfirm key={name} {...params}/>;
        case MODALS.UNSAVED_CHANGE_QUIZ_TAKE_CONFIRM:
            return <UnsavedTakeQuizConfirm key={name} {...params}/>
        case MODALS.QUIZ_AI:
            return <AiQuiz key={name} {...params}/>
        case MODALS.REMOVE_ACKNOWLEDGMENT_REQUIRE:
            return <RemoveAcknowledgmentRequire key={name} {...params}/>
        case MODALS.TASKLIST_UNIT_EDIT:
            return <TaskListUnitEdit key={name} {...params}/>
        case MODALS.TASKLIST_EDIT:
            return <TaskListEdit key={name} {...params}/>
        case MODALS.TASK_EDIT:
            return <TaskEdit key={name} {...params}/>
        case MODALS.TASK_REPORT_EDIT:
            return <TaskReportEdit key={name} {...params}/>
        case MODALS.TASK_REPORT_VIEW_ONLY:
            return <TaskReportViewOnly key={name} {...params}/>
        case MODALS.TASKLIST_UNIT_DELETE:
            return <DeleteTaskListUnit key={name} {...params}/>
        case MODALS.TASK_LIST_DELETE:
            return <TaskListDelete key={name} {...params}/>
        case MODALS.TASK_DELETE:
            return <TaskDelete key={name} {...params}/>
        case MODALS.YEAR_CALENDAR:
            return <YearCalendar key={name} {...params}/>
        case MODALS.EXCEPTIONS_CALENDAR:
            return <ExceptionsCalendar key={name} {...params}/>
        case MODALS.COPY_TO_FOR_TASK:
            return <CopyToForTaskModal key={name} {...params}/>
        case MODALS.DOCUMENT_VIEW:
            return <DocumentViewModal key={name} {...params}/>
        case MODALS.CROP:
            return <CropModal key={name} {...params}/>
        case MODALS.LIGHTBOX:
            return <LightBoxModal key={name} {...params}/>
        case MODALS.IMPORT_DOC:
            return (
                <Suspense key={name} fallback={null}>
                    <ImportDocLazy/>
                </Suspense>
            );
        default:
            return null;
    }
};
